// The three actions that ask before they act; the list and the detail page share the copy.
export const ALLOCATION_CONFIRM = Object.freeze({
  edit: 'edit',
  reject: 'reject',
  revoke: 'revoke',
});

const BUILDERS = Object.freeze({
  [ALLOCATION_CONFIRM.edit]: (t) => ({
    title: t('ALLOCATIONS_ACTION_EDIT_DECLARATION'),
    description: t('ALLOCATIONS_CONFIRM_EDIT_BODY'),
    confirmLabel: t('COMMON_CONTINUE'),
  }),
  [ALLOCATION_CONFIRM.reject]: (t, row) => ({
    title: t('ALLOCATIONS_CONFIRM_REJECT_TITLE', { transactionId: row?.transactionId ?? '' }),
    description: t('ALLOCATIONS_CONFIRM_REJECT_BODY'),
    confirmLabel: t('ALLOCATIONS_CONFIRM_REJECT_ACTION'),
  }),
  [ALLOCATION_CONFIRM.revoke]: (t, row) => ({
    title: t('ALLOCATIONS_CONFIRM_REVOKE_TITLE', { transactionId: row?.transactionId ?? '' }),
    description: t('ALLOCATIONS_CONFIRM_REVOKE_BODY', {
      sentFrom: row?.facilityName ?? '',
      customer: row?.sendTo ?? '',
    }),
    confirmLabel: t('ALLOCATIONS_CONFIRM_REVOKE_ACTION'),
  }),
});

export const buildAllocationConfirm = (t, confirm) =>
  confirm ? BUILDERS[confirm.kind](t, confirm.row) : null;
